(function () {
  var CAROUSEL_CSS =
    '.elovia-reviews-summary{display:flex;flex-wrap:wrap;align-items:center;justify-content:center;gap:.45rem .65rem;margin-top:.15rem}' +
    '.elovia-reviews-summary__stars{display:inline-flex;gap:.1rem;color:#ffcc00;font-size:1.05rem}' +
    '.elovia-reviews-summary__text{font-size:.95rem;font-weight:600;color:#4a4458}' +
    '.elovia-reviews-carousel{position:relative;margin-top:1.1rem}' +
    '.elovia-reviews-track{display:flex;gap:1rem;overflow-x:auto;scroll-snap-type:x mandatory;-webkit-overflow-scrolling:touch;padding:.35rem .25rem 1rem;scrollbar-width:none;scroll-behavior:smooth}' +
    '.elovia-reviews-track::-webkit-scrollbar{display:none}' +
    '.elovia-reviews-card{flex:0 0 min(88vw,340px);scroll-snap-align:center;background:#fff5f8;border:1px solid rgba(236,72,153,.22);border-radius:12px;padding:.9rem .95rem 1rem;box-shadow:none}' +
    '.elovia-reviews-card__profile{display:flex;align-items:flex-start;gap:.55rem;margin-bottom:.55rem;min-width:0}' +
    '.elovia-reviews-card__avatar{flex-shrink:0;width:44px;height:44px;border-radius:50%;object-fit:cover;background:#f3e8ff}' +
    '.elovia-reviews-card__identity{flex:1;min-width:0}' +
    '.elovia-reviews-card__name{margin:0 0 .2rem;font-size:.8125rem;font-weight:700;color:#ec4899;line-height:1.2}' +
    '.elovia-reviews-card__rating-row{display:flex;align-items:center;flex-wrap:wrap;gap:.25rem .4rem}' +
    '.elovia-reviews-card__stars{display:inline-flex;gap:.06rem;color:#ddd;font-size:.75rem}' +
    '.elovia-reviews-card__star.is-on{color:#f5b301}' +
    '.elovia-reviews-card__verified{font-size:.6875rem;font-weight:600;color:#ec4899}' +
    '.elovia-reviews-card__time{flex-shrink:0;margin-left:auto;font-size:.6875rem;line-height:1.2;color:#65676b;white-space:nowrap}' +
    '.elovia-reviews-card__title{margin:0 0 .35rem;font-size:.95rem;line-height:1.3;color:#1a1520}' +
    '.elovia-reviews-card__body{margin:0;font-size:.8125rem;line-height:1.5;color:#050505}' +
    '.elovia-reviews-nav{display:none;position:absolute;top:50%;transform:translateY(-50%);z-index:2;width:38px;height:38px;border:1px solid rgba(236,72,153,.18);border-radius:50%;background:#fff;color:#ec4899;box-shadow:0 6px 18px rgba(236,72,153,.12);cursor:pointer;align-items:center;justify-content:center;padding:0}' +
    '.elovia-reviews-nav--prev{left:-.35rem}.elovia-reviews-nav--next{right:-.35rem}' +
    '.elovia-reviews-swipe-hint{margin:0;text-align:center;font-size:.78rem;font-weight:600;color:#8a8494}' +
    '.elovia-reviews-dots{display:flex;justify-content:center;flex-wrap:wrap;gap:.35rem;margin-top:.35rem}' +
    '.elovia-reviews-dot{width:8px;height:8px;border-radius:50%;border:none;background:#ddd;padding:0;cursor:pointer;flex-shrink:0}' +
    '.elovia-reviews-dot.is-active{background:#ec4899;width:20px;border-radius:4px}' +
    '.elovia-reviews-cta,.elovia-write-review-btn,.elovia-judgeme-section .jdgm-write-rev-link{display:none!important}' +
    '#elovia-customer-reviews #judgeme_product_reviews,#elovia-customer-reviews .jdgm-rev-widg,#elovia-customer-reviews .jdgm-review-widget{display:none!important}' +
    '@media(min-width:750px){.elovia-reviews-nav{display:inline-flex}.elovia-reviews-swipe-hint{display:none}.elovia-reviews-track{padding-left:1.75rem;padding-right:1.75rem}}';

  function injectStyles() {
    if (document.getElementById('elovia-reviews-carousel-css')) return;
    var style = document.createElement('style');
    style.id = 'elovia-reviews-carousel-css';
    style.textContent = CAROUSEL_CSS;
    document.head.appendChild(style);
  }

  function starsHtml(rating) {
    var html = '';
    for (var i = 1; i <= 5; i += 1) {
      html += '<span class="elovia-reviews-card__star' + (i <= rating ? ' is-on' : '') + '">★</span>';
    }
    return html;
  }

  var FEMALE_PROFILES = [
    { name: 'Isabella Cruz', photo: 11 },
    { name: 'Hannah Cooper', photo: 23 },
    { name: 'Chloe Bennett', photo: 34 },
    { name: 'Sophia Reed', photo: 45 },
    { name: 'Emma Walsh', photo: 52 },
    { name: 'Grace Mitchell', photo: 61 },
    { name: 'Lily Parker', photo: 68 },
    { name: 'Ava Thompson', photo: 72 },
    { name: 'Charlotte Hayes', photo: 77 },
    { name: 'Natalie Brooks', photo: 81 },
    { name: 'Rachel Morgan', photo: 14 },
    { name: 'Jessica Turner', photo: 19 },
    { name: 'Lauren Price', photo: 26 },
    { name: 'Megan Foster', photo: 31 },
    { name: 'Ashley Cole', photo: 38 },
    { name: 'Brittany Lane', photo: 42 },
    { name: 'Samantha Reid', photo: 48 },
    { name: 'Victoria Shaw', photo: 55 },
    { name: 'Katherine Moore', photo: 63 },
    { name: 'Jennifer Blake', photo: 70 },
    { name: 'Amanda Hayes', photo: 75 },
    { name: 'Michelle Grant', photo: 79 },
    { name: 'Stephanie Ward', photo: 84 },
    { name: 'Nicole Pierce', photo: 88 }
  ];

  function profileForIndex(index) {
    return FEMALE_PROFILES[index % FEMALE_PROFILES.length];
  }

  function avatarUrl(photoId) {
    return 'https://randomuser.me/api/portraits/women/' + photoId + '.jpg';
  }

  function timeAgo(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return '';
    var mins = Math.floor((Date.now() - d.getTime()) / 60000);
    if (mins < 60) return Math.max(1, mins) + ' minutes ago';
    var hrs = Math.floor(mins / 60);
    if (hrs < 24) return hrs + ' hours ago';
    var days = Math.floor(hrs / 24);
    if (days < 30) return days + ' days ago';
    return Math.floor(days / 30) + ' months ago';
  }

  function getJsonUrl() {
    var meta = document.querySelector('meta[name="elovia-reviews-data"]');
    if (meta && meta.getAttribute('content')) return meta.getAttribute('content');
    var carousel = document.querySelector('.elovia-reviews-carousel[data-reviews-url]');
    if (carousel) return carousel.getAttribute('data-reviews-url');
    var script = document.querySelector('script[src*="secondary.js"]');
    if (script) return script.src.replace('secondary.js', 'elovia-judgeme-reviews.json');
    return '';
  }

  function buildCarousel(section, data) {
    if (section.getAttribute('data-elovia-carousel-ready') === 'true') return;
    if (section.querySelector('.elovia-reviews-track .elovia-reviews-card')) {
      section.setAttribute('data-elovia-carousel-ready', 'true');
      return;
    }

    var reviews = data.reviews || [];
    if (!reviews.length) return;

    injectStyles();

    section.querySelectorAll('#judgeme_product_reviews, .jdgm-review-widget, .jdgm-rev-widg, .elovia-judgeme-section__badge, .elovia-reviews-cta').forEach(function (node) {
      node.remove();
    });

    var summary = section.querySelector('#eloviaReviewsSummary, .elovia-reviews-summary');
    if (!summary) {
      summary = document.createElement('div');
      summary.className = 'elovia-reviews-summary';
      summary.id = 'eloviaReviewsSummary';
      var header = section.querySelector('.elovia-judgeme-section__header');
      if (header) header.appendChild(summary);
    }
    summary.innerHTML =
      '<span class="elovia-reviews-summary__stars" aria-hidden="true">' +
      starsHtml(Math.round(data.average_rating || 5)) +
      '</span><span class="elovia-reviews-summary__text">' +
      (data.average_rating || 5) +
      ' · ' +
      (data.count || reviews.length) +
      ' reviews</span>';

    var inner = section.querySelector('.elovia-judgeme-section__inner') || section;
    var oldCarousel = inner.querySelector('.elovia-reviews-carousel');
    if (oldCarousel) oldCarousel.remove();
    var oldDots = inner.querySelector('#eloviaReviewsDots, .elovia-reviews-dots');
    if (oldDots) oldDots.remove();
    var oldHint = inner.querySelector('.elovia-reviews-swipe-hint');
    if (oldHint) oldHint.remove();

    var carousel = document.createElement('div');
    carousel.className = 'elovia-reviews-carousel';
    carousel.innerHTML =
      '<button type="button" class="elovia-reviews-nav elovia-reviews-nav--prev" aria-label="Previous review" hidden><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<div class="elovia-reviews-track" id="eloviaReviewsTrack" role="list" aria-label="Customer review cards"></div>' +
      '<button type="button" class="elovia-reviews-nav elovia-reviews-nav--next" aria-label="Next review" hidden><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>';

    var hint = document.createElement('p');
    hint.className = 'elovia-reviews-swipe-hint';
    hint.textContent = 'Swipe to read more reviews →';

    var dots = document.createElement('div');
    dots.className = 'elovia-reviews-dots';
    dots.id = 'eloviaReviewsDots';

    inner.appendChild(carousel);
    inner.appendChild(hint);
    inner.appendChild(dots);

    var track = carousel.querySelector('#eloviaReviewsTrack');
    var prevBtn = carousel.querySelector('.elovia-reviews-nav--prev');
    var nextBtn = carousel.querySelector('.elovia-reviews-nav--next');

    reviews.forEach(function (review, index) {
      var profile = profileForIndex(index);
      var name = profile.name;
      var when = timeAgo(review.created_at);
      var card = document.createElement('article');
      card.className = 'elovia-reviews-card';
      card.setAttribute('role', 'listitem');
      card.innerHTML =
        '<div class="elovia-reviews-card__profile">' +
          '<img class="elovia-reviews-card__avatar" src="' + avatarUrl(profile.photo) + '" alt="" width="44" height="44" loading="lazy">' +
          '<div class="elovia-reviews-card__identity">' +
            '<p class="elovia-reviews-card__name"></p>' +
            '<div class="elovia-reviews-card__rating-row">' +
              '<span class="elovia-reviews-card__stars">' + starsHtml(review.rating) + '</span>' +
              '<span class="elovia-reviews-card__verified">Verified</span>' +
            '</div>' +
          '</div>' +
          (when ? '<time class="elovia-reviews-card__time">' + when + '</time>' : '') +
        '</div>' +
        (review.title ? '<h3 class="elovia-reviews-card__title"></h3>' : '') +
        '<p class="elovia-reviews-card__body"></p>';
      card.querySelector('.elovia-reviews-card__name').textContent = name;
      if (review.title) card.querySelector('.elovia-reviews-card__title').textContent = review.title;
      card.querySelector('.elovia-reviews-card__body').textContent = review.body || '';
      track.appendChild(card);

      var dot = document.createElement('button');
      dot.type = 'button';
      dot.className = 'elovia-reviews-dot' + (index === 0 ? ' is-active' : '');
      dot.setAttribute('aria-label', 'Review ' + (index + 1));
      dot.addEventListener('click', function () {
        card.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
      });
      dots.appendChild(dot);
    });

    var cards = track.querySelectorAll('.elovia-reviews-card');
    function updateDots() {
      var idx = 0;
      var min = 1e9;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.scrollLeft - 12);
        if (dist < min) {
          min = dist;
          idx = i;
        }
      });
      dots.querySelectorAll('.elovia-reviews-dot').forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === idx);
      });
    }

    function scrollByCard(direction) {
      var idx = 0;
      var min = 1e9;
      cards.forEach(function (card, i) {
        var dist = Math.abs(card.offsetLeft - track.scrollLeft - 12);
        if (dist < min) {
          min = dist;
          idx = i;
        }
      });
      var target = cards[Math.min(cards.length - 1, Math.max(0, idx + direction))];
      if (target) target.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
    }

    if (cards.length > 1) {
      prevBtn.hidden = false;
      nextBtn.hidden = false;
      prevBtn.addEventListener('click', function () { scrollByCard(-1); });
      nextBtn.addEventListener('click', function () { scrollByCard(1); });
    }

    track.addEventListener('scroll', updateDots, { passive: true });
    updateDots();
    section.setAttribute('data-elovia-carousel-ready', 'true');
    section.classList.add('elovia-judgeme-section--carousel-ready');
  }

  function reposition(section) {
    var finalCta = document.querySelector('section[id*="__final_cta"]');
    if (!finalCta || !section) return;
    var wrapper = section.closest('section[id*="__customer_reviews"]') || section;
    if (wrapper.previousElementSibling !== finalCta) {
      finalCta.insertAdjacentElement('afterend', wrapper);
    }
  }

  var initStarted = false;

  function init() {
    if (initStarted) return;
    var url = getJsonUrl();
    if (!url) return;

    var sections = document.querySelectorAll('#elovia-customer-reviews');
    if (!sections.length) return;

    initStarted = true;
    injectStyles();

    fetch(url)
      .then(function (res) { return res.json(); })
      .then(function (data) {
        sections.forEach(function (section, index) {
          if (index > 0) {
            var dup = section.closest('section[id*="__customer_reviews"]') || section;
            dup.remove();
            return;
          }
          buildCarousel(section, data);
          reposition(section);
        });
      })
      .catch(function () {
        initStarted = false;
      });
  }

  function scheduleInit() {
    init();
    window.setTimeout(init, 400);
    window.setTimeout(init, 1500);
  }

  function watchJudgemeInject() {
    var section = document.getElementById('elovia-customer-reviews');
    if (!section || section.getAttribute('data-elovia-carousel-ready') === 'true') return;
    var observer = new MutationObserver(function () {
      if (section.querySelector('#judgeme_product_reviews, .jdgm-rev-widg')) {
        init();
      }
    });
    observer.observe(section, { childList: true, subtree: true });
    window.setTimeout(function () { observer.disconnect(); }, 8000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      scheduleInit();
      watchJudgemeInject();
    });
  } else {
    scheduleInit();
    watchJudgemeInject();
  }
})();
